<template>
<div class="apply-progress" >
    <ul v-if="category === 'A'" class="step-progressbar">
        <!-- 단계를 현재 진행 중일 때!  -->
        <li class="pointer step-progressbar__item" v-if="viewProgress('terms')" :class="[this.pageType === 'terms' ? 'step-progressbar__item--active': '', this.pageType === 'terms' ? setColor(): '']" @click="step('terms')">신청동의</li>
        <!-- 단계를 아직 미 진행 중일 때!  -->
        <li class="pointer step-progressbar__item" v-if="viewProgress('info')" @click="step('info')" :class="[this.pageType === 'info' ? 'step-progressbar__item--active': '', this.pageType === 'info' ? setColor(): '']">신청안내</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('select')" @click="step('select')" :class="[this.pageType === 'select' ? 'step-progressbar__item--active': '', this.pageType === 'select' ? setColor(): '']">클래스선택</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('input')" @click="step('input')" :class="[this.pageType === 'input' ? 'step-progressbar__item--active': '', this.pageType === 'input' ? setColor(): '']">정보입력</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('payment')" @click="step('payment')" :class="[this.pageType === 'payment' ? 'step-progressbar__item--active': '', this.pageType === 'payment' ? setColor(): '']">결제</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('complete')" @click="step('complete')" :class="[this.pageType === 'complete' ? 'step-progressbar__item--active': '', this.pageType === 'complete' ? setColor(): '']">신청결과</li>
    </ul>
    <ul v-else-if="category === 'B'" class="step-progressbar">
        <!-- 단계를 현재 진행 중일 때!  -->
        <li class="pointer step-progressbar__item" v-if="viewProgress('terms')" @click="step('terms')" :class="[this.pageType === 'terms' ? 'step-progressbar__item--active': '', this.pageType === 'terms' ? setColor(): '']">신청동의</li>
        <!-- 단계를 아직 미 진행 중일 때!  -->
        <li class="pointer step-progressbar__item" v-if="viewProgress('select')" @click="step('select')" :class="[this.pageType === 'select' ? 'step-progressbar__item--active': '', this.pageType === 'select' ? setColor(): '']">클래스선택</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('info')" @click="step('info')" :class="[this.pageType === 'info' ? 'step-progressbar__item--active': '', this.pageType === 'info' ? setColor(): '']">신청안내</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('input')" @click="step('input')" :class="[this.pageType === 'input' ? 'step-progressbar__item--active': '', this.pageType === 'input' ? setColor(): '']">정보입력</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('payment')" @click="step('payment')" :class="[this.pageType === 'payment' ? 'step-progressbar__item--active': '', this.pageType === 'payment' ? setColor(): '']">결제</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('complete')" @click="step('complete')" :class="[this.pageType === 'complete' ? 'step-progressbar__item--active': '', this.pageType === 'complete' ? setColor(): '']">신청결과</li>
    </ul>
    <ul v-else class="step-progressbar">
        <!-- 단계를 현재 진행 중일 때!  -->
        <li class="pointer step-progressbar__item" v-if="viewProgress('terms')" @click="step('terms')" :class="[this.pageType === 'terms' ? 'step-progressbar__item--active': '', this.pageType === 'terms' ? setColor(): '']">신청동의</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('input')" @click="step('input')" :class="[this.pageType === 'input' ? 'step-progressbar__item--active': '', this.pageType === 'input' ? setColor(): '']">정보입력</li>
        <!-- 단계를 아직 미 진행 중일 때!  -->
        <li class="pointer step-progressbar__item" v-if="viewProgress('info')" @click="step('info')" :class="[this.pageType === 'info' ? 'step-progressbar__item--active': '', this.pageType === 'info' ? setColor(): '']">신청안내</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('select')" @click="step('select')" :class="[this.pageType === 'select' ? 'step-progressbar__item--active': '', this.pageType === 'select' ? setColor(): '']">클래스선택</li>

        <li class="pointer step-progressbar__item" v-if="viewProgress('payment')" @click="step('payment')" :class="[this.pageType === 'payment' ? 'step-progressbar__item--active': '', this.pageType === 'payment' ? setColor(): '']">결제</li>
        <li class="pointer step-progressbar__item" v-if="viewProgress('complete')" @click="step('complete')" :class="[this.pageType === 'complete' ? 'step-progressbar__item--active': '', this.pageType === 'complete' ? setColor(): '']">신청결과</li>
    </ul>
</div>
</template>

<script>
export default {
    data: () => ({
        category: "A", // 카테고리 A, B, C 유형 존재
        progressOrder: [], // 프로그래스 순서 배열
        pageType: "", // 페이지 타입
        pointColor: 'blue'
    }),

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
        $route(to) {
            this.loadProgressData();
        },
    },

    mounted() {
        this.loadProgressData();
    },

    methods: {
        setColor() {
            if (this.pointColor === 'Blue') {
                return 'blue'
            } else if (this.pointColor === 'Red') {
                return 'red'
            } else if (this.pointColor === 'Green') {
                return 'green'
            }
        },

        loadProgressData() {
            var pathArray = this.$route.fullPath.split("/");
            var length = pathArray.length;
            this.pageType = pathArray[length - 1];

            this.pointColor = sessionStorage.getItem('pointColor')

            // console.log("pathArray", pathArray);

            // console.log("this.pageType", this.pageType);
            if (!sessionStorage.getItem("category")) {
                var pageIdx = sessionStorage.getItem("pageIdx");
                var params = {
                    pageIdx: pageIdx,
                };
                this.axios
                    .get(this.axios.root + this.axios.port + `/sugang/page/${pageIdx}`, {
                        params: params,
                    })
                    .then((res) => {
                        // console.log("res", res);
                        if (res.data.err === 0) {
                            this.category = res.data.pageInfo.category;
                            sessionStorage.setItem("category", this.category);
                            this.loadSugang(sessionStorage.getItem("pageIdx"));
                            // this.setOrder()
                        } else {
                            alert(res.data.result);
                        }
                    })
                    .catch((err) => {
                        // console.log(err);
                        alert(err);
                    });
            } else {
                this.category = sessionStorage.getItem("category");
                this.loadSugang(sessionStorage.getItem("pageIdx"));
                // this.setOrder()
            }
        },

        // 선택한 페이지 클래스만 출력되게
        viewProgress(type) {
            return this.progressOrder.includes(type);
        },

        // 수강신청 불러오기
        async loadSugang(pageIdx) {
            await this.axios
                .get(this.axios.root + this.axios.port + `/sugang/page/${pageIdx}`)
                .then((res) => {
                    // console.log(res);
                    if (res.data.err === 0) {
                        var pOrder = [];
                        for (var i = 1; i <= 8; i++) {
                            for (var item of res.data.menu) {
                                if (item.order === i.toString()) {
                                    if (item.status === "Y") {
                                        if (item.name === "agree") {
                                            pOrder.push("terms");
                                        } else if (item.name === "guide") {
                                            pOrder.push("info");
                                        } else if (item.name === "choose") {
                                            pOrder.push("select");
                                        } else if (item.name === "info") {
                                            pOrder.push("input");
                                        } else if (item.name === "pay") {
                                            pOrder.push("payment");
                                        } else if (item.name === "complete") {
                                            pOrder.push("complete");
                                        }
                                    }
                                }
                            }
                        }

                        this.progressOrder = pOrder;

                        sessionStorage.setItem("pOrder", JSON.stringify(pOrder));
                        sessionStorage.setItem("category", res.data.pageInfo.category);
                    }
                });
        },

        // 각 단계로 이동
        step(position) {
            if (
                this.progressOrder.indexOf(position) >
                this.progressOrder.indexOf(sessionStorage.getItem("step"))
            ) {
                alert("이전 클래스를 먼저 진행해 주세요.");
                return false;
            } else {
                this.$router.push(`/user/reg/${position}`);
            }
        },

        // 카테고리에 따른 프로그레스 순서 정해주는 함수
        setOrder() {
            if (this.category === "A") {
                this.progressOrder = [
                    "terms",
                    "info",
                    "select",
                    "input",
                    "payment",
                    "complete",
                ];
            } else if (this.category === "B") {
                this.progressOrder = [
                    "terms",
                    "select",
                    "info",
                    "input",
                    "payment",
                    "complete",
                ];
            } else {
                this.progressOrder = [
                    "terms",
                    "input",
                    "info",
                    "select",
                    "payment",
                    "complete",
                ];
            }
            sessionStorage.setItem("pOrder", JSON.stringify(this.progressOrder));
        },
    },
};
</script>
